import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, services, states } from '@/utils'

import button from '@/components/button'
import buttonRefresh from '@/components/button/refresh'
import pagination from '@/components/pagination'
import preloader from '@/components/preloader'
import detailsItem from '@/components/services/sendings/outgoing/details/item'

function renderReleaseBucketButton(h) {
  if (this.restData[services.sendings].find.bucketLength > 0) {
    return h(
      button,
      {
        props: {
          label: this.restData[services.sendings].find.bucketLength,
          icon: icons.add,
          mode: buttonModes.flat,
          color: Colors.primary,
          disabled: this.restData[services.sendings].find.state === 'loading'
        },
        on: {
          click: () => {
            this.rest[services.sendings].bucketRelease()
          }
        }
      }
    )
  }
}
function renderButtonRefresh(h) {
  return h(
    buttonRefresh,
    {
      props: {
        disabled: this.downloadable,
        label: this.getTranslate(`${services.sendings}.buttons.refresh`),
        tooltip: this.getTranslate(`${services.sendings}.tooltips.refresh`),
        state: this.restData[services.sendings].find.state,
        shortClickMethod: () => this.rest[services.sendings].find(),
        longClickMethod: () => this.rest[services.sendings].find({}, { noCache: true })
      }
    }
  )
}
function renderTitle(h) {
  return h(
    'div',
    {
      class: {
        'faic grid-gap--8': true,
        fw: this.viewport.breakpoint.smDown
      }
    },
    [
      this.$slots.title,

      h('div', { class: 'ff' }),

      h(
        'div',
        {
          class: 'grid grid-gap--8',
          style: { 'grid-template-columns': this.restData[services.sendings].find.bucketLength > 0 ? 'repeat(2, auto)' : 'auto' }
        },
        [
          renderReleaseBucketButton.call(this, h),
          renderButtonRefresh.call(this, h)
        ]
      )
    ]
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 pa-2'
    },
    [
      renderTitle.call(this, h),
      this.$slots.filter
    ]
  )
}

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder preloader__holder--absolute pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.restData[services.sendings].find.state === states.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderItem(h, item) {
  return h(
    detailsItem,
    {
      props: { value: item }
    }
  )
}
function renderItems(h) {
  return h(
    components['expansion-panels'],
    {
      style: { position: 'relative' },
      props: { flat: true }
    },
    [
      this.restData[services.sendings].find.data.map(item => {
        return renderItem.call(this, h, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderBody(h) {
  if (this.restData[services.sendings].find.pagination.total > 0) {
    return renderItems.call(this, h)
  } else {
    switch (this.restData[services.sendings].find.state) {
      case states.loading: return renderPreloader.call(this, h)
      case states.ready:
      default: return h(components.empty)
    }
  }
}

function renderDivider(h) {
  if (Array.isArray(this.restData[services.sendings].find.data) && this.restData[services.sendings].find.data.length) {
    return h('g-divider')
  }
}

function renderPagination(h) {
  return h(
    'div',
    {
      class: 'fjcfe pa-2'
    },
    [
      h(
        pagination,
        {
          props: {
            value: this.restData[services.sendings].find.pagination,
            service: services.sendings
          },
          on: {
            input: event => {
              this.restData[services.sendings].find.pagination = event
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'fc ff'
    },
    [
      renderHeader.call(this, h),
      renderDivider.call(this, h),
      renderPagination.call(this, h),
      renderDivider.call(this, h),
      renderBody.call(this, h),
      renderDivider.call(this, h),
      renderPagination.call(this, h)
    ]
  )
}
